import { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { createPortal } from "react-dom"
import { useNavigate } from "react-router-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import Deposit from "../transactions/Deposit"
import LoginGlobal from "../data/LoginGlobal"
import LuckyDraw8 from "../snippets/games/LuckyDraw8"

export default function LuckyDraw() {
  const navigate = useNavigate()
  const data = promotionsData.find(
    (promo) => promo.title === "8's Your Lucky Draw"
  )
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isDepositOpen, setIsDepositOpen] = useState(false)
  const [isEntryOpen, setIsEntryOpen] = useState(false)

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const openLuckyDrawEntry = () => {
    setIsEntryOpen(true)
  }

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>8's Your Lucky Draw</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      {isEntryOpen && <LuckyDraw8 onClose={() => setIsEntryOpen(false)} />}
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion">Promotions</a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1> 8's Your Lucky Draw </h1>{" "}
                  <h2>All Eyes on 8, Play Smart & Win Big!</h2>
                  <div className="promotion-tnc-period">
                    <p>
                      <strong> Promo Period: </strong>
                      <span>FGH Raffle draw on October 8th, 18th and 28th</span>
                    </p>
                  </div>
                  <div className="promotion-tnc-mechanic-content">
                    {isLoggedIn && (
                      <div className="promotion-tnc-btn-wrapper">
                        <button
                          className="promotion-cta-btn"
                          onClick={openLuckyDrawEntry}
                        >
                          View Entry
                        </button>
                      </div>
                    )}
                    <strong> Terms & Conditions </strong>{" "}
                    <ol>
                      <li>
                        Deposit/Withdraw any amount with the number '8' during
                        the promo period — such as{" "}
                        <strong className="highlight">
                          ₱108, ₱280, ₱800, etc.
                        </strong>
                        <ul>
                          <li>
                            Each qualifying deposit/withdrawal transaction = 1
                            Lucky Draw entry
                          </li>
                          <li>
                            No limit on entries - The more deposit/withdraw with
                            ‘8’, the higher your chances of winning!
                          </li>
                        </ul>
                      </li>
                      <li>
                        Lucky Draw Schedule & Awarding of Winners:
                        <div className="table-wrapper">
                          <table className="promotion-tnc-table">
                            <thead>
                              <th colSpan={2}>Promo Cut-off</th>
                              <th>Awarding</th>
                            </thead>
                            <tbody>
                              <tr>
                                <td>1st Draw</td>
                                <td>Oct 1 (12PM) – Oct 8 (11:59 AM)</td>
                                <td>Oct 8 (2PM)</td>
                              </tr>
                              <tr>
                                <td>2nd Draw</td>
                                <td>Oct 11 (12PM) – Oct 18 (11:59 AM)</td>
                                <td>Oct 18(2PM)</td>
                              </tr>
                              <tr>
                                <td>3rd Draw</td>
                                <td>Oct 21 (12PM) – Oct 28 (11:59 AM)</td>
                                <td> Oct 28 (2PM)</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </li>
                      <li>
                        There will be eighteen (18) winners of raffle prizes in
                        each draw.
                        <div className="table-wrapper">
                          <table className="promotion-tnc-table">
                            <thead>
                              <th>Winners</th>
                              <th>No. of Winners</th>
                              <th>Prize</th>
                              <th>Rollover</th>
                            </thead>
                            <tbody>
                              <tr>
                                <td>1st</td>
                                <td>1</td>
                                <td>₱2,888.00</td>
                                <td rowSpan={6}>1x</td>
                              </tr>
                              <tr>
                                <td>2nd</td>
                                <td>1</td>
                                <td>₱1,888.00</td>
                              </tr>
                              <tr>
                                <td>3rd</td>
                                <td>1</td>
                                <td>₱888.00</td>
                              </tr>
                              <tr>
                                <td>4th - 5th</td>
                                <td>2</td>
                                <td>₱588.00</td>
                              </tr>
                              <tr>
                                <td>6th - 10th</td>
                                <td>5</td>
                                <td>₱288.00</td>
                              </tr>
                              <tr>
                                <td>11th - 18th</td>
                                <td>8</td>
                                <td>₱188.00</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </li>
                      <li>
                        All prizes will be subjected to one-time rollover to any
                        games in FGH before any withdrawals.
                      </li>
                      <li>
                        FGH reserves the right to modify, suspend, or terminate
                        this promotion at any time without prior notice.
                      </li>
                    </ol>
                    <div className="promotion-tnc-cta">
                      {isLoggedIn ? (
                        <button
                          type="button"
                          className="promotion-cta-btn"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsDepositOpen(true)}
                        >
                          Deposit Now
                        </button>
                      ) : (
                        <LoginGlobal
                          label="Deposit Now"
                          btnClass="promotion-cta-btn"
                          onlyBtn={true}
                        />
                      )}
                    </div>
                    {isDepositOpen &&
                      createPortal(
                        <div className="modal-portal">
                          <Deposit
                            onClose={() => setIsDepositOpen(false)}
                            defaultBonusName="New Member Package Bonus"
                          />
                        </div>,
                        document.body
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
